import type { TApiResponse } from '@/types/api-types/TApiResponse'
import ConfigApiUrls from './endpoints'
import BaseApiRequest from '../BaseApiRequest'

class ConfigApiRequest extends BaseApiRequest {
  async getUnits(): TApiResponse {
    return this.get(ConfigApiUrls.UNITS())
  }
}

export default ConfigApiRequest
